import { Flex } from '@chakra-ui/react';

import { InputToolbar } from './toolbar/InputToolbar';
import { LabelTextToolbar } from './toolbar/LabelTextToolbar';

interface FormWidgetToolbarProps {
  isActive: boolean;
}

export const FormWidgetToolbar = ({ isActive }: FormWidgetToolbarProps) => {
  return (
    <Flex gap='2' align='center' data-testid='form-widget-toolbar'>
      {isActive ? <InputToolbar /> : <LabelTextToolbar />}
    </Flex>
  );
};
